"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemClient = void 0;
class SystemClient {
    constructor(client) {
        this.client = client;
    }
    /**
     * Check the health of the R2R server.
     */
    async health() {
        return await this.client.makeRequest("GET", "health");
    }
    /**
     * Get the configuration settings for the R2R server.
     * @returns
     */
    async settings() {
        return await this.client.makeRequest("GET", "system/settings");
    }
    /**
     * Get statistics about the server, including the start time, uptime,
     * CPU usage, and memory usage.
     * @returns
     */
    async status() {
        return await this.client.makeRequest("GET", "system/status");
    }
}
exports.SystemClient = SystemClient;
//# sourceMappingURL=system.js.map